import React from "react";
import AttendanceRecordsShared from "../attendance/AttendanceRecordsShared";

export default function AdminAttendanceRecords() {
  return <AttendanceRecordsShared backPath="/admin/attendance" />;
}
